import React, { useState, useEffect, useCallback } from 'react';
import { Cookie } from 'lucide-react';
import { Button } from './ui/button';

// Non-sensitive consent flag persisted across sessions per GDPR best practice
// (using sessionStorage would force the banner to reappear every visit, which
//  is worse UX and would re-prompt users who already gave consent).
const STORAGE_KEY = 'mazli_cookie_consent_v1';

const readConsent = () => {
  try {
    return localStorage.getItem(STORAGE_KEY);
  } catch (err) {
    console.warn('[CookieBanner] localStorage read failed:', err);
    return null;
  }
};

const writeConsent = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, value);
  } catch (err) {
    console.warn('[CookieBanner] localStorage write failed:', err);
  }
};

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!readConsent()) {
      const t = setTimeout(() => setVisible(true), 400);
      return () => clearTimeout(t);
    }
    return undefined;
  }, []);

  const handleAccept = useCallback(() => {
    writeConsent('1');
    setVisible(false);
  }, []);

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] px-4 pb-4 sm:pb-6 pointer-events-none"
      role="dialog"
      aria-live="polite"
      aria-label="Sütik használata">
      <div className="pointer-events-auto max-w-4xl mx-auto bg-white/95 backdrop-blur-md border-2 border-cyan-200 shadow-2xl rounded-2xl p-5 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="hidden sm:flex w-12 h-12 flex-shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-cyan-100 to-teal-100 text-cyan-600">
          <Cookie className="w-6 h-6" />
        </div>
        <p className="text-sm sm:text-base text-gray-700 leading-relaxed flex-1">
          Weboldalunk a jobb felhasználói élmény érdekében alapvető sütiket (cookie-kat) használ. Az oldal böngészésével elfogadja a sütik használatát.
        </p>
        <Button
          onClick={handleAccept}
          data-testid="cookie-accept-btn"
          className="w-full sm:w-auto bg-gradient-to-r from-cyan-500 to-teal-500 hover:from-cyan-600 hover:to-teal-600 text-white font-semibold px-6 py-2 rounded-full shadow-lg hover:shadow-xl transition-all duration-300">
          Elfogadom
        </Button>
      </div>
    </div>
  );
};

export default CookieBanner;
